if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.priceWrapper = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.submitButton = this.querySelector(`#StickySubmitButton-${this.sectionId}`);
        this.image = this.querySelector('[data-image-sticky-add-to-cart] img');

        this.selects = [...this.querySelectorAll('[data-sticky-option]')].sort(
          (a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)
        );

        try {
          this.variants = JSON.parse(this.querySelector('[data-sticky-variants]')?.textContent || '[]');
        } catch (e) {
          this.variants = [];
        }
        this.onOptionChange = this.onOptionChange.bind(this);
      }

      connectedCallback() {
        this.observeTargetButton();

        this.selects.forEach((select) => {
          select.addEventListener('change', this.onOptionChange);
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.onVariantChange(event.data);
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.selects.forEach((select) => select.removeEventListener('change', this.onOptionChange));
      }

      observeTargetButton() {
        this.hidden = true;

        const targetId = this.dataset.targetId;
        const target = targetId && document.getElementById(targetId);
        if (!target) return;

        this.observer = new IntersectionObserver(([entry]) => {
          const rootTop = entry.rootBounds?.top ?? 0;
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < rootTop;
          this.hidden = !scrolledPast;
        });
        this.observer.observe(target);
      }

      onOptionChange(event) {
        const select = event.currentTarget;
        const index = Number(select.dataset.optionIndex);
        const selected = this.selects.map((s) => s.value);

        let variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));

        if (!variant) {
          const candidates = this.variants.filter((v) => v.options[index] === select.value);
          variant = candidates.find((v) => v.available) || candidates[0];
          if (variant) {
            this.selects.forEach((s) => {
              const value = variant.options[Number(s.dataset.optionIndex)];
              if (s.value !== value) {
                s.value = value;
                s.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          }
        }

        if (!variant) return;

        this.applyToMainForm(variant, select);
        this.updateButtonState(variant);
      }

      applyToMainForm(variant, select) {
        const form = this.submitButton?.form;

        const idInput = form?.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;

        const name = select.dataset.optionName;
        const value = select.value;
        const scope = document.getElementById(`shopify-section-${this.sectionId}`) || document;
        const controls = [...scope.querySelectorAll('select, input[type="radio"]')].filter(
          (el) => !this.contains(el)
        );
        const matches = (el) =>
          el.tagName === 'SELECT'
            ? el.name === `options[${name}]`
            : (el.name === name || el.name === `options[${name}]`) && el.value === value;
        const main = controls.find((el) => matches(el) && el.form === form) || controls.find(matches);
        if (!main) return;

        if (main.tagName === 'SELECT') main.value = value;
        else main.checked = true;
        main.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateButtonState(variant) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('disabled', !variant.available);
        const label = this.submitButton.querySelector('span');
        if (label) {
          label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        }
      }

      onVariantChange({ html, variant }) {
        if (this.priceWrapper) {
          const sourcePrice = html.getElementById(`price-${this.sectionId}`);
          if (sourcePrice) this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        if (this.submitButton) {
          const sourceButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          const disabled = !variant || (sourceButton?.hasAttribute('disabled') ?? true);
          this.submitButton.toggleAttribute('disabled', disabled);
          const label = this.submitButton.querySelector('span');
          if (label && sourceButton) {
            label.textContent = sourceButton.querySelector('span')?.textContent.trim() ?? label.textContent;
          }
        }

        if (!variant) return;

        const options = variant.options || [variant.option1, variant.option2, variant.option3];
        this.selects.forEach((select) => {
          const value = options[Number(select.dataset.optionIndex)];
          if (value != null && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        const src = variant.featured_image?.src;
        if (src && this.image) {
          this.image.removeAttribute('srcset');
          this.image.src = `${src}${src.includes('?') ? '&' : '?'}width=144`;
        }
      }
    }
  );
}